import { Skeleton } from "ui";

export function HorizontalBarsLoadingSkeleton() {
  return (
    <div className="flex flex-col space-y-9">
      <Skeleton className="w-11/12" />
      <Skeleton className="w-8/12" />
      <Skeleton className="w-1/2" />
      <Skeleton className="w-1/3" />
    </div>
  );
}
